import { DraftTextOrPlaceholderTextConfiguration } from '@/types';
import { getTextSizeForStyle } from '@/utils/text/getTextSizeForStyle';
import { adjustTextStyleOffset } from './adjustTextStyleOffset';

export function updateFontSize(
  configuration: DraftTextOrPlaceholderTextConfiguration,
  fontSize: number
) {
  const text = configuration.text;
  const textContent = text.content;
  const textStyle = text.style;

  textStyle.fontSize = fontSize;
  adjustTextStyleOffset(textStyle, textContent);
  configuration.size = getTextSizeForStyle(textStyle, textContent);
}
